import jwt_decode from "jwt-decode";
import * as constants from '../../constants/CONSTANT'
import authApi from '../../api/authApi';
const helper = {
  checkPermission(perm) {
    let userInfo = jwt_decode(localStorage.getItem('token'));

    if (!userInfo.permissions)
      return false;
    return userInfo.permissions.some(function (el) {
      return el.name === perm;
    });
  },
  // Added by muskan khan
  async fetchWithAuth(url, method, body = {}, bodyType = undefined) {
    let accessToken = localStorage.getItem('token');
    const refreshToken = sessionStorage.getItem('r-t');

    if (!accessToken || !refreshToken)
      throw new Error('No tokens available');

    const { exp } = jwt_decode(accessToken);
    const { exp: refreshExp } = jwt_decode(refreshToken);
    if (Date.now() < refreshExp * 1000) {
      if (Date.now() >= exp * 1000) {
        const response = await fetch(constants.API_BASE_URL + '/api/auth/refresh',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ refreshToken }),
          });


        if (!response.ok)
          throw new Error('Failed to refresh token');

        const data = await response.json();
        if (data.success) {
          accessToken = data.authToken;
          localStorage.setItem('token', accessToken);
        }
      }

      if (method === 'GET' || method === 'DELETE') {
        const response = await fetch(url, {
          method,
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
          }
        });

        if (response.status === 401) {
          await authApi.handleUnauthorized(response);
        }

        return response;
      } else if (method === 'POST' || method === 'PUT') {
        const response = await fetch(url, {
          method,
          mode: 'cors',
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            ...((bodyType !== 'form') && { 'Content-Type': 'application/json' }),
          },
          body
        });

        if (response.status === 401) {
          await authApi.handleUnauthorized(response);
        }

        return response;
      }
    } else {
      authApi.logout();
    }
  }
}

export default helper
